import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Row, Button, Form, Modal } from "react-bootstrap";
const CategoryOrganizationCoding = () => {
  const navigate = useNavigate()
  return (
    <section className="cms-create-categories">
      <Row>
        <div className="crud-categories">
          <div className="crud-title">
            <h1> Category GSI</h1>
          </div>
          <div className="crud-category">
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}>



              <Button type="button" onClick={() => navigate("add")} variant="warning">
                Add Category GSI
              </Button>

            </div>


          </div>
        </div>
        <hr />
        <Row>

        </Row>
      </Row>
    </section>
  )
}

export default CategoryOrganizationCoding